const STORAGE_KEY = "servall_user_location";

export const formatDistance = (km) => {
    if (km == null || Number.isNaN(km)) return "";
    if (km < 1) return `${Math.round(km * 1000)} m away`;
    if (km < 10) return `${km.toFixed(1)} km away`;
    return `${Math.round(km)} km away`;
};

export const loadStoredLocation = () => {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (typeof parsed?.lat === "number" && typeof parsed?.lng === "number") return parsed;
    } catch {
        /* ignore */
    }
    return null;
};

export const storeLocation = (coords) => {
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ ...coords, saved_at: Date.now() }));
    } catch {
        /* ignore */
    }
};

export const clearStoredLocation = () => {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch {
        /* ignore */
    }
};

export const requestUserLocation = () =>
    new Promise((resolve, reject) => {
        if (typeof navigator === "undefined" || !navigator.geolocation) {
            reject(new Error("Geolocation is not supported on this device."));
            return;
        }
        navigator.geolocation.getCurrentPosition(
            (pos) => {
                const coords = {
                    lat: pos.coords.latitude,
                    lng: pos.coords.longitude,
                    accuracy: pos.coords.accuracy,
                };
                storeLocation(coords);
                resolve(coords);
            },
            (err) => {
                const messages = {
                    1: "Location access was denied. Allow location in your browser settings, or pick a city on the outlet page.",
                    2: "Could not detect your location. Check GPS / network and try again.",
                    3: "Location request timed out. Please try again.",
                };
                reject(new Error(messages[err.code] || "Could not get your location."));
            },
            { enableHighAccuracy: false, timeout: 15000, maximumAge: 300000 }
        );
    });
